import { render, staticRenderFns } from "./AffiliateWeeklyCommissions.vue?vue&type=template&id=34eb63ba&"
import script from "./AffiliateWeeklyCommissions.vue?vue&type=script&lang=js&"
export * from "./AffiliateWeeklyCommissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports